export const BOOTSTRAP_PROFILE_TYPES = 'BOOTSTRAP_PROFILE_TYPES'
export const ADD_PROFILE_TYPE = 'ADD_PROFILE_TYPE'
export const UPDATE_PROFILE_TYPE = 'UPDATE_PROFILE_TYPE'
export const DELETE_PROFILE_TYPE = 'DELETE_PROFILE_TYPE'
export const LOAD_PROFILES = 'LOAD_PROFILES'
export const ADD_ROLE = 'ADD_ROLE'
